export default __webpack_public_path__ + "static/media/408.b6bcd99c.png";